import { useSuspenseQuery } from "@tanstack/react-query";
import { useLoggedInUser } from "../LoggedInUserProvider";
import sortBy from "lodash/sortBy";
import { getAllUsers, getUser } from "./userApi";
import { useOnPropagate } from "@/api/PropagateProvider";

export function useUser(userId: string) {
    const key = "getUser";

    const { data: user } = useSuspenseQuery({
        queryKey: [key, userId],
        queryFn: () => getUser(userId)
    });

    useOnPropagate(key, p => {
        p.onSingleDefaults("user", x => [key, x.id]);
    });

    return user;
}

export function useCurrentUser() {
    const { userId } = useLoggedInUser();
    return useUser(userId);
}

export const useUsers = () => {
    const key = "getAllUsers";

    const { data: rawUsers } = useSuspenseQuery({
        queryKey: [key],
        queryFn: getAllUsers
    });

    const users = sortBy(rawUsers, x =>
        `${x.firstName} ${x.lastName}`.toLocaleLowerCase()
    );

    useOnPropagate(key, p => {
        p.onCollectionDefaults("user", [key]);
    });

    return users;
};

// re-export for prefetching (react-compiler eslint doesn't like passing hooks as reference)
export const reexported__useCurrentUser = useCurrentUser;
export const reexported__useUsers = useUsers;
